<template>
    <v-card>
        <v-card-title class="pa-0">
            <v-row wrap>
                <span class="ml-4">{{item.customer.name}}</span>
                <v-spacer />
                <span v-if="!item.isChild" class="mr-4">T: {{item.dailyTotals[0].total}}</span>
            </v-row>
        </v-card-title>
        <v-card-text class="pa-0">
            <v-row class="pl-1 pr-1">
                <v-col cols="12">
                    <v-chip small v-if="item.dailyTotals[item.day -1].isPdr" color="yellow"><strong>PDR - {{item.pdrAmount}}</strong></v-chip>
                    <v-chip small v-if="item.dailyTotals[item.day -1].isAlloys" color="orange"><strong>Alloys <span v-if="item.alloyTypes">- {{item.alloyTypes}}</span></strong></v-chip>
                    <v-chip small v-if="item.dailyTotals[item.day -1].isCCar" color="green"><strong>Courtesy Car - <span v-if="item.ccTypeManual">M</span><span v-else>A</span></strong></v-chip>
                    <v-chip small v-if="item.dailyTotals[item.day -1].isDropOff" color="#996699" class="white--text"><strong>Drop Off</strong></v-chip>
                    <v-chip small v-if="item.dailyTotals[item.day -1].isPickUp" color="#333399" class="white--text"><strong>Pick Up</strong></v-chip>
                </v-col>
                <v-col cols="12">
                    <div v-if="!item.isChild" style="display: inline-block">
                        <v-btn v-if="!item.invoiceSent" :loading="isInvoicing" :disabled="isInvoicing" small @click="sendInvoice(item)" color="info" text><v-icon>mdi-currency-gbp</v-icon></v-btn>
                        <v-btn small @click="viewBooking(item)" color="primary" text><v-icon>mdi-calendar</v-icon></v-btn>
                        <v-btn small :to="`/booking/${item._id}`" color="primary" text><v-icon>mdi-magnify</v-icon></v-btn>
                        <v-btn :loading="isGenerating" :disabled="isGenerating" small @click="printBooking(item)" color="primary" text><v-icon>mdi-printer</v-icon></v-btn>
                        <v-btn small v-if="item.dailyTotals[item.day -1] && item.dailyTotals[item.day -1].isCCar" @click="viewCCar(item)" color="primary" text><v-icon>mdi-car</v-icon></v-btn>
                    </div>
                    <div style="display: inline-block">
                        <v-btn small @click="deleteBooking(item)" color="error" text><v-icon>mdi-delete</v-icon></v-btn>
                        <h5 v-if="item.dailyTotals.length > 0 && item.isChild && item.dailyTotals[item.day -1]" class="subtitle-1 float-right">(DT: <strong>{{item.dailyTotals[item.day -1].total}}</strong>)</h5>
                        <h5 v-if="item.dailyTotals.length === 0 && item.isChild" class="subtitle-1 float-right">(DT: <strong>{{item.total}}</strong>)</h5>
                    </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
    import {BookingsHttp} from "../../http/bookings";
    import {EventBus} from "../../EventBus";

    export default {
        name: "BookingCard",
        props: {
            item: Object
        },
        data() {
            return {
                isLoading: false,
                isGenerating: false,
                isInvoicing: false
            }
        },
        methods: {
            async viewBooking(item) {
                await this.$store.dispatch('bookings/setActiveBooking', item);
                await this.$store.dispatch('bookings/setManageBookingDialog', true);
            },
            async viewCCar(item) {
                await this.$store.dispatch('bookings/setActiveBooking', item);
                await this.$router.push(`/booking/car/${item._id}`);
            },
            async deleteBooking(item) {
                await this.$store.dispatch('bookings/setActiveBooking', item);
                await this.$store.dispatch('bookings/setDeleteBookingDialog', true);
            },
            async sendInvoice(item) {
                this.isInvoicing = true;
                try {
                    await BookingsHttp.sendInvoice(item._id);
                    EventBus.$emit('message', {message: 'Invoice Sent', type: 'success'});
                    EventBus.$emit('refresh-bookings');
                } catch (e) {
                    EventBus.$emit('message', {message: e, type: 'error'});
                } finally {
                    this.isInvoicing = false;
                }
            },
            async printBooking(item){
                this.isGenerating = true;
                const blob = await BookingsHttp.printBooking(item._id);
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                window.open(link.href, '_blank');
                this.isGenerating = false;
            },
        }
    }
</script>

<style scoped>

</style>
